<template>
    <div class="form">
        <h4 class="step-title">
            <label for="currentResidenceLength">How long have you lived at your current residence?</label>
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <button-list v-bind:items="lengths" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "CurrentResidenceLength",
        components: {
            ButtonList
        },
        data: function() {
            return {
                lengths: [
                    { text: "Less than 6 months", value: 3 },
                    { text: "6 months to 1 year", value: 9 },
                    { text: "1 to 3 years", value: 24 },
                    { text: "More than 3 years", value: 36 }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(length) {
                this.lead.currentResidenceLengthInMonths = length;
                this.$emit("complete", this.$options.name, this.lead.currentResidenceLengthInMonths);
            }
        }
    }
</script>
